module.exports = __webpack_public_path__ + "img/close.594ca202.png";